function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRdt45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      fill: 0,
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z ",
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,35.5 L 33,35.5 L 33,35.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13,31.5 L 32,31.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,29.5 L 31,29.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14,16.5 L 31,16.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 34,14",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinejoin: "miter"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdt45);
export default __webpack_public_path__ + "static/media/rdt45.9859c67519a6585df38a9a99be17a2c6.svg";
export { ForwardRef as ReactComponent };